import Vue from "vue";
import Router from "vue-router";
import ResetPassword from "../components/ResetPassword.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "ResetPassword",
      component: ResetPassword
    }
  ]
});
